export default {"src":"/login-app/[GIT_HASH]/_next/static/media/home.ff5d7dd4.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};